var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKBalloons(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "K_Balloons",
    "data-name": "K Balloons",
    xmlns: "http://www.w3.org/2000/svg",
    width: 150.159,
    height: 42,
    viewBox: "0 0 150.159 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M104.881,78.345h6.488c3.043,0,4.821,1.3,4.821,3.629a2.9,2.9,0,0,1-1.624,2.832,3.5,3.5,0,0,1,2.348,3.644c0,2.6-1.669,3.9-4.813,3.9h-7.219Zm6.429,5.248c1.156,0,1.852-.426,1.852-1.241,0-.845-.662-1.216-1.882-1.216h-3.428v2.457Zm.685,5.96c1.219,0,1.909-.515,1.911-1.616.018-1.069-.691-1.634-1.911-1.634h-4.142v3.25Z",
    transform: "translate(-104.881 -50.631)",
    fill: "#0084cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M140.115,77.4l8.032,14.609h-3.3l-1.419-2.641h-6.683l-1.41,2.641h-3.36Zm1.951,9.424-1.986-3.7-1.974,3.7Z",
    transform: "translate(-114.535 -50.296)",
    fill: "#0084cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M166.931,78.345h3.076l-.017,11.211h7.09v2.8H166.931Z",
    transform: "translate(-126.987 -50.631)",
    fill: "#0084cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M193.553,78.345h3.076l-.017,11.211h7.09v2.8H193.553Z",
    transform: "translate(-136.472 -50.631)",
    fill: "#0084cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M218.237,85.195a7.526,7.526,0,1,1,7.522,7.288A7.287,7.287,0,0,1,218.237,85.195Zm11.973.006a4.459,4.459,0,1,0-4.46,4.406A4.343,4.343,0,0,0,230.21,85.2Z",
    transform: "translate(-145.266 -50.483)",
    fill: "#0084cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M252.2,85.195a7.526,7.526,0,1,1,7.522,7.288A7.287,7.287,0,0,1,252.2,85.195Zm11.973.006a4.459,4.459,0,1,0-4.46,4.406A4.343,4.343,0,0,0,264.175,85.2Z",
    transform: "translate(-157.366 -50.483)",
    fill: "#0084cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M287.426,78.345h3.046l7.105,9.471V78.345h3.059V92.351h-3.013L290.5,82.9v9.455h-3.076Z",
    transform: "translate(-169.915 -50.631)",
    fill: "#0084cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M319.488,90.789,321.14,88.4a9.53,9.53,0,0,0,4.7,1.269c1.491,0,2.424-.538,2.477-1.421.052-.846-.479-1.156-2.137-1.521l-1.737-.384c-3.131-.691-4.388-2.117-4.394-4.236,0-2.33,2.371-4.054,5.454-4.059a11.028,11.028,0,0,1,5.547,1.5L329.5,81.936a7.269,7.269,0,0,0-3.707-1.116c-1.444-.005-2.462.489-2.456,1.383,0,.789.6,1.172,1.99,1.475l1.912.417c3,.657,4.249,1.934,4.254,4.157,0,2.422-2.323,4.187-5.795,4.191A12.312,12.312,0,0,1,319.488,90.789Z",
    transform: "translate(-181.338 -50.526)",
    fill: "#0084cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M119.662,57.9,109.7,46.931V57.9h-4.824V35.944H109.7v8.668l8.126-8.668h6.426l-9.592,9.843L125.982,57.9Z",
    transform: "translate(-104.881 -35.525)",
    fill: "#0084cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M138.982,47.146v-11.2h4.83v11.2c0,4.167,1.635,6.577,5.584,6.577,3.976,0,5.585-2.41,5.585-6.55V35.944h4.884V47.173c0,6.753-3.613,11.016-10.469,11.016C142.513,58.188,138.982,53.959,138.982,47.146Z",
    transform: "translate(-117.03 -35.525)",
    fill: "#0084cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M180.063,35.944h10.17c4.771,0,7.557,2.032,7.557,5.69a4.544,4.544,0,0,1-2.545,4.44c1.446.511,3.68,1.883,3.68,5.711,0,4.07-2.615,6.115-7.544,6.115H180.063Zm10.08,8.228c1.81,0,2.9-.668,2.9-1.945,0-1.325-1.038-1.906-2.949-1.906h-5.373v3.851Zm1.072,9.343c1.913,0,2.993-.807,3-2.532.028-1.676-1.085-2.563-3-2.563h-6.492v5.095Z",
    transform: "translate(-131.666 -35.525)",
    fill: "#0084cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M216.4,40.767V57.9h4.823V35.944l0,0Z",
    transform: "translate(-144.612 -35.525)",
    fill: "#0084cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M270.218,35.944h17.327V40.32H275.014v3.84l8.8.023V48.42h-8.8v5.095h12.558V57.9H270.218Z",
    transform: "translate(-163.785 -35.525)",
    fill: "#0084cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M319.259,57.9,309.3,46.931V57.9h-4.823V35.944H309.3v8.668l8.126-8.668h6.426l-9.592,9.843L325.579,57.9Z",
    transform: "translate(-175.99 -35.525)",
    fill: "#0084cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M248.28,50.977a6.974,6.974,0,0,1-5.572,2.639,6.908,6.908,0,1,1,0-13.816,6.987,6.987,0,0,1,5.51,2.561l3.7-2.894a11.322,11.322,0,0,0-2.619-2.3l-3.367,3.367V35.7a12.7,12.7,0,0,0-3.212-.41,11.413,11.413,0,1,0,0,22.813,11.832,11.832,0,0,0,9.315-4.3Z",
    transform: "translate(-149.788 -35.293)",
    fill: "#0084cc"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3-2",
    "data-name": "Path 3",
    d: "M104.881,78.345h6.488c3.043,0,4.821,1.3,4.821,3.629a2.9,2.9,0,0,1-1.624,2.832,3.5,3.5,0,0,1,2.348,3.644c0,2.6-1.669,3.9-4.813,3.9h-7.219Zm6.429,5.248c1.156,0,1.852-.426,1.852-1.241,0-.845-.662-1.216-1.882-1.216h-3.428v2.457Zm.685,5.96c1.219,0,1.909-.515,1.911-1.616.018-1.069-.691-1.634-1.911-1.634h-4.142v3.25Z",
    transform: "translate(-104.881 -50.631)",
    fill: "#0084cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4-2",
    "data-name": "Path 4",
    d: "M140.115,77.4l8.032,14.609h-3.3l-1.419-2.641h-6.683l-1.41,2.641h-3.36Zm1.951,9.424-1.986-3.7-1.974,3.7Z",
    transform: "translate(-114.535 -50.296)",
    fill: "#0084cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5-2",
    "data-name": "Path 5",
    d: "M166.931,78.345h3.076l-.017,11.211h7.09v2.8H166.931Z",
    transform: "translate(-126.987 -50.631)",
    fill: "#0084cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6-2",
    "data-name": "Path 6",
    d: "M193.553,78.345h3.076l-.017,11.211h7.09v2.8H193.553Z",
    transform: "translate(-136.472 -50.631)",
    fill: "#0084cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7-2",
    "data-name": "Path 7",
    d: "M218.237,85.195a7.526,7.526,0,1,1,7.522,7.288A7.287,7.287,0,0,1,218.237,85.195Zm11.973.006a4.459,4.459,0,1,0-4.46,4.406A4.343,4.343,0,0,0,230.21,85.2Z",
    transform: "translate(-145.266 -50.483)",
    fill: "#0084cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8-2",
    "data-name": "Path 8",
    d: "M252.2,85.195a7.526,7.526,0,1,1,7.522,7.288A7.287,7.287,0,0,1,252.2,85.195Zm11.973.006a4.459,4.459,0,1,0-4.46,4.406A4.343,4.343,0,0,0,264.175,85.2Z",
    transform: "translate(-157.366 -50.483)",
    fill: "#0084cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9-2",
    "data-name": "Path 9",
    d: "M287.426,78.345h3.046l7.105,9.471V78.345h3.059V92.351h-3.013L290.5,82.9v9.455h-3.076Z",
    transform: "translate(-169.915 -50.631)",
    fill: "#0084cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10-2",
    "data-name": "Path 10",
    d: "M319.488,90.789,321.14,88.4a9.53,9.53,0,0,0,4.7,1.269c1.491,0,2.424-.538,2.477-1.421.052-.846-.479-1.156-2.137-1.521l-1.737-.384c-3.131-.691-4.388-2.117-4.394-4.236,0-2.33,2.371-4.054,5.454-4.059a11.028,11.028,0,0,1,5.547,1.5L329.5,81.936a7.269,7.269,0,0,0-3.707-1.116c-1.444-.005-2.462.489-2.456,1.383,0,.789.6,1.172,1.99,1.475l1.912.417c3,.657,4.249,1.934,4.254,4.157,0,2.422-2.323,4.187-5.795,4.191A12.312,12.312,0,0,1,319.488,90.789Z",
    transform: "translate(-181.338 -50.526)",
    fill: "#0084cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11-2",
    "data-name": "Path 11",
    d: "M119.662,57.9,109.7,46.931V57.9h-4.824V35.944H109.7v8.668l8.126-8.668h6.426l-9.592,9.843L125.982,57.9Z",
    transform: "translate(-104.881 -35.525)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12-2",
    "data-name": "Path 12",
    d: "M138.982,47.146v-11.2h4.83v11.2c0,4.167,1.635,6.577,5.584,6.577,3.976,0,5.585-2.41,5.585-6.55V35.944h4.884V47.173c0,6.753-3.613,11.016-10.469,11.016C142.513,58.188,138.982,53.959,138.982,47.146Z",
    transform: "translate(-117.03 -35.525)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13-2",
    "data-name": "Path 13",
    d: "M180.063,35.944h10.17c4.771,0,7.557,2.032,7.557,5.69a4.544,4.544,0,0,1-2.545,4.44c1.446.511,3.68,1.883,3.68,5.711,0,4.07-2.615,6.115-7.544,6.115H180.063Zm10.08,8.228c1.81,0,2.9-.668,2.9-1.945,0-1.325-1.038-1.906-2.949-1.906h-5.373v3.851Zm1.072,9.343c1.913,0,2.993-.807,3-2.532.028-1.676-1.085-2.563-3-2.563h-6.492v5.095Z",
    transform: "translate(-131.666 -35.525)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14-2",
    "data-name": "Path 14",
    d: "M216.4,40.767V57.9h4.823V35.944l0,0Z",
    transform: "translate(-144.612 -35.525)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15-2",
    "data-name": "Path 15",
    d: "M270.218,35.944h17.327V40.32H275.014v3.84l8.8.023V48.42h-8.8v5.095h12.558V57.9H270.218Z",
    transform: "translate(-163.785 -35.525)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16-2",
    "data-name": "Path 16",
    d: "M319.259,57.9,309.3,46.931V57.9h-4.823V35.944H309.3v8.668l8.126-8.668h6.426l-9.592,9.843L325.579,57.9Z",
    transform: "translate(-175.99 -35.525)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17-2",
    "data-name": "Path 17",
    d: "M248.28,50.977a6.974,6.974,0,0,1-5.572,2.639,6.908,6.908,0,1,1,0-13.816,6.987,6.987,0,0,1,5.51,2.561l3.7-2.894a11.322,11.322,0,0,0-2.619-2.3l-3.367,3.367V35.7a12.7,12.7,0,0,0-3.212-.41,11.413,11.413,0,1,0,0,22.813,11.832,11.832,0,0,0,9.315-4.3Z",
    transform: "translate(-149.788 -35.293)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKBalloons);
export default __webpack_public_path__ + "static/media/K Balloons.56a66638b7b3c8d65fd9fc69e19d93f5.svg";
export { ForwardRef as ReactComponent };